import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveDirective as _resolveDirective } from "vue"
import _imports_0 from '../../assets/img/add-card/sbp.svg'
import _imports_1 from '../../assets/img/add-card/card-full.svg'


const _hoisted_1 = { class: "w-full mt-4" }
const _hoisted_2 = { class: "mt-2" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "mt-4 flex justify-center" }
const _hoisted_5 = { class: "mt-3" }
const _hoisted_6 = { class: "relative mt-4 flex w-full items-center text-grey" }
const _hoisted_7 = { class: "w-full" }
const _hoisted_8 = {
  key: 0,
  class: "w-full"
}
const _hoisted_9 = {
  key: 1,
  class: "relative w-full rounded-md bg-yellowLight p-5"
}
const _hoisted_10 = { class: "mt-1" }
const _hoisted_11 = { class: "mt-4" }
const _hoisted_12 = { class: "mt-1" }
const _hoisted_13 = {
  class: "mt-1 flex flex-nowrap overflow-y-hidden whitespace-nowrap pb-3",
  ref: "banksList"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "text-sm truncate" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "text-sm" }
const _hoisted_19 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 2,
  class: "relative w-full rounded-md bg-yellowLight p-5 font-medium"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "mt-4" }
const _hoisted_25 = {
  key: 0,
  class: "mt-2 flex justify-center text-grey"
}
const _hoisted_26 = {
  key: 0,
  class: "mt-4 flex justify-center"
}
const _hoisted_27 = {
  key: 1,
  class: "mt-4 flex justify-center"
}
const _hoisted_28 = { class: "mt-6" }
const _hoisted_29 = { class: "relative mt-4 flex w-full items-center text-grey" }
const _hoisted_30 = { class: "w-full" }
const _hoisted_31 = {
  key: 0,
  class: "w-full"
}
const _hoisted_32 = {
  key: 1,
  class: "relative w-full rounded-md bg-yellowLight p-5"
}
const _hoisted_33 = { class: "mt-1" }
const _hoisted_34 = { class: "mt-4" }
const _hoisted_35 = { class: "mt-1" }
const _hoisted_36 = {
  key: 2,
  class: "relative w-full rounded-md bg-yellowLight p-5"
}
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "mt-4" }
const _hoisted_40 = {
  key: 0,
  class: "mt-2 flex justify-center text-grey"
}
const _hoisted_41 = {
  key: 0,
  class: "mt-4 flex justify-center"
}
const _hoisted_42 = {
  key: 1,
  class: "mt-4 flex justify-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_InputComponent = _resolveComponent("InputComponent")!
  const _component_ChooseSBPBank = _resolveComponent("ChooseSBPBank")!
  const _component_SBPIcon = _resolveComponent("SBPIcon")!
  const _component_TelegramBanner = _resolveComponent("TelegramBanner")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_CardIcon = _resolveComponent("CardIcon")!
  const _component_StatusModal = _resolveComponent("StatusModal")!
  const _component_WikiComponent = _resolveComponent("WikiComponent")!
  const _component_standart_template = _resolveComponent("standart-template")!
  const _directive_auto_animate = _resolveDirective("auto-animate")!

  return (_openBlock(), _createBlock(_component_standart_template, null, {
    default: _withCtx(() => [
      _createVNode(_component_PageHeader, {
        title: "Добавление карты",
        "back-url": "home"
      }),
      _createVNode(_component_ChooseSBPBank, {
        modelValue: _ctx.allBankDialog,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.allBankDialog) = $event))
      }, {
        body: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_InputComponent, {
              model: _ctx.bankFilter,
              modelValue: _ctx.bankFilter,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bankFilter) = $event)),
              background: "bg-greyLight",
              placeholder: "Поиск",
              maxlength: "32"
            }, null, 8, ["model", "modelValue"])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allBanksListFilter, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index + 100,
                class: _normalizeClass(["px-3 py-4 border-opacity-75", { 'border-t': index != 0 }]),
                onClick: ($event: any) => (_ctx.chooseOtherBank(item))
              }, [
                _createElementVNode("div", null, _toDisplayString(item.bank_name), 1)
              ], 10, _hoisted_3))
            }), 128))
          ], 512), [
            [_vShow, _ctx.allBanksListFilter && _ctx.allBanksListFilter?.length > 0]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_4, " Банк не найден ", 512), [
            [_vShow, _ctx.allBanksListFilter?.length == 0]
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("section", _hoisted_5, [
        _cache[23] || (_cache[23] = _createElementVNode("div", { class: "flex items-center font-medium text-grey" }, [
          _createElementVNode("img", {
            class: "mr-3",
            src: _imports_0
          }),
          _createElementVNode("div", null, "СБП")
        ], -1)),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
            (!_ctx.isAddSBP)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleFormSBP())),
                  class: "flex min-h-[113px] w-full items-center rounded-md bg-greyLight p-5"
                }, [
                  _createVNode(_component_SBPIcon, {
                    class: "absolute bottom-0 right-0 rounded-br-md opacity-20",
                    color: "#A6B0CF"
                  }),
                  (!_ctx.isAddSBP)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[16] || (_cache[16] = [
                        _createElementVNode("div", null, "Нажмите, чтобы", -1),
                        _createElementVNode("div", null, "добавить СБП", -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.isAddSBP && !_ctx.isSendOtpSbp)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_SBPIcon, {
                    class: "absolute bottom-0 right-0 rounded-br-md opacity-20",
                    color: "#FFD92F"
                  }),
                  _createElementVNode("div", null, [
                    _cache[17] || (_cache[17] = _createElementVNode("div", null, "Название карты", -1)),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_InputComponent, {
                        placeholder: "Обязательно к заполнению",
                        rounded: "lg",
                        model: _ctx.sbpCardName,
                        modelValue: _ctx.sbpCardName,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.sbpCardName) = $event)),
                        height: "h-10",
                        maxlength: "30",
                        border: false,
                        onKeyup: _cache[4] || (_cache[4] = ($event: any) => (_ctx.removeNumberInName('sbpCardName')))
                      }, null, 8, ["model", "modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _cache[18] || (_cache[18] = _createElementVNode("div", null, "Номер телефона", -1)),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_InputComponent, {
                        placeholder: "(***) *** ** **",
                        rounded: "lg",
                        model: _ctx.sbpNumber,
                        modelValue: _ctx.sbpNumber,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.sbpNumber) = $event)),
                        height: "h-10",
                        onPaste: _ctx.onPaste,
                        type: "tel",
                        maxlength: "15",
                        prefix: "+7",
                        mask: '(###) ### ## ##',
                        border: false
                      }, null, 8, ["model", "modelValue", "onPaste"])
                    ])
                  ]),
                  _cache[20] || (_cache[20] = _createElementVNode("div", { class: "mt-4" }, "Выберите банк из списка", -1)),
                  _createElementVNode("div", _hoisted_13, [
                    (_ctx.otherBank)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.chooseSbpBank = null)),
                          class: _normalizeClass(["z-10 mr-3 flex h-[120px] min-w-[120px] flex-col justify-between rounded-md p-3 bg-greyLight transition-all duration-75", { 'border-2 border-blue': !_ctx.chooseSbpBank }])
                        }, [
                          _createElementVNode("div", null, [
                            _createElementVNode("img", {
                              src: require(`@/assets/img/add-card/sbp-color.svg`),
                              alt: "bank image",
                              class: "h-[28px]"
                            }, null, 8, _hoisted_14)
                          ]),
                          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.otherBank.bank_name), 1)
                        ], 2))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainBanksList, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: _normalizeClass(["z-10 mr-3 flex h-[120px] min-w-[120px] flex-col justify-between rounded-md p-3 transition-all duration-75", {
                    'border-2 border-blue':
                      _ctx.chooseSbpBank &&
                      _ctx.chooseSbpBank.identifier === item.identifier,
                  }]),
                        style: _normalizeStyle({ backgroundColor: item.color }),
                        onClick: ($event: any) => (_ctx.choosePopularBank(item))
                      }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("img", {
                            class: "h-[28px]",
                            src: 
                        require(`@/assets/img/add-card/sbp-banks/${item.icon}.svg`)
                      ,
                            alt: "bank image"
                          }, null, 8, _hoisted_17)
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_18, _toDisplayString(item.displayName), 1),
                          (item.displayDescription.length > 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(item.displayDescription), 1))
                            : _createCommentVNode("", true)
                        ])
                      ], 14, _hoisted_16))
                    }), 128)),
                    _createElementVNode("div", {
                      class: "z-10 mr-3 flex h-[120px] min-w-[120px] flex-col justify-between rounded-md p-3 bg-greyLight",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.allBankDialog = true))
                    }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("img", {
                          src: require(`@/assets/img/add-card/sbp-color.svg`),
                          alt: "bank image",
                          class: "h-[28px]"
                        }, null, 8, _hoisted_20)
                      ]),
                      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "text-sm" }, "Все банки", -1))
                    ])
                  ], 512)
                ]))
              : _createCommentVNode("", true),
            (_ctx.isSendOtpSbp)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createVNode(_component_SBPIcon, {
                    color: "#FFD92F",
                    class: "absolute bottom-0 right-0 rounded-br-md opacity-20"
                  }),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      (_ctx.typeOtp === 'phone')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [...(_cache[21] || (_cache[21] = [
                            _createTextVNode(" На ваш телефон поступит звонок ", -1),
                            _createElementVNode("div", null, "Возьмите трубку и прослушайте код", -1)
                          ]))]))
                        : _createCommentVNode("", true),
                      (_ctx.typeOtp === 'telegram')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [...(_cache[22] || (_cache[22] = [
                            _createTextVNode(" На ваш Telegram поступил код ", -1),
                            _createElementVNode("div", null, "Прочитайте и впишите ниже", -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_InputComponent, {
                        placeholder: 
                    _ctx.typeOtp == 'phone' ? 'Код из звонка' : 'Код из Telegram'
                  ,
                        rounded: "lg",
                        model: _ctx.otpNumber,
                        modelValue: _ctx.otpNumber,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.otpNumber) = $event)),
                        height: "h-10",
                        maxlength: "5",
                        border: false
                      }, null, 8, ["placeholder", "model", "modelValue"])
                    ]),
                    (_ctx.callTries < 3 && _ctx.typeOtp == 'phone')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.nextCallTime > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, " Позвонить еще раз (" + _toDisplayString(_ctx.nextCallTime) + "c) ", 1))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "mt-2 flex cursor-pointer justify-center text-blue",
                                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onSubmitNewSbp && _ctx.onSubmitNewSbp(...args)))
                              }, " Позвонить еще раз "))
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.typeOtp === 'phone')
                    ? (_openBlock(), _createBlock(_component_TelegramBanner, {
                        key: 0,
                        class: "mt-5"
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])), [
            [_directive_auto_animate]
          ])
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", null, [
          (_ctx.isAddSBP && !_ctx.isSendOtpSbp)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createVNode(_component_ButtonComponent, {
                  "input-class": "px-10",
                  rounded: "lg",
                  height: "10",
                  loading: _ctx.hasRequest,
                  onClickAction: _ctx.onSubmitNewSbp,
                  "disabled-text": "Проверяем",
                  title: "Сохранить",
                  disabled: 
              _ctx.sbpNumber.length != 15 ||
              !_ctx.sbpCardName.length ||
              (_ctx.chooseSbpBank == null && _ctx.otherBank == null)
            
                }, null, 8, ["loading", "onClickAction", "disabled"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isSendOtpSbp)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createVNode(_component_ButtonComponent, {
                  "input-class": "px-10",
                  loading: _ctx.hasRequest,
                  rounded: "lg",
                  height: "10",
                  onClickAction: _ctx.codeConfirmation,
                  title: "Сохранить",
                  disabled: _ctx.otpNumber.length != 5
                }, null, 8, ["loading", "onClickAction", "disabled"])
              ]))
            : _createCommentVNode("", true)
        ])), [
          [_directive_auto_animate]
        ])
      ]),
      _createElementVNode("section", _hoisted_28, [
        _cache[29] || (_cache[29] = _createElementVNode("div", { class: "flex items-center font-medium text-grey" }, [
          _createElementVNode("img", {
            class: "mr-3",
            src: _imports_1
          }),
          _createElementVNode("div", null, "Карта")
        ], -1)),
        _createElementVNode("div", _hoisted_29, [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_30, [
            (!_ctx.isAddCard)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.toggleFormCard())),
                  class: "flex min-h-[113px] w-full items-center rounded-md bg-greyLight p-5"
                }, [
                  _createVNode(_component_CardIcon, {
                    color: "#A6B0CF",
                    class: "absolute bottom-0 right-0 rounded-br-md opacity-20"
                  }),
                  (!_ctx.isAddCard)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [...(_cache[24] || (_cache[24] = [
                        _createElementVNode("div", null, "Нажмите, чтобы", -1),
                        _createElementVNode("div", null, "добавить карту", -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.isAddCard && !_ctx.isSendOtp)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createVNode(_component_CardIcon, {
                    color: "#FFD92F",
                    class: "absolute bottom-0 right-0 rounded-br-md opacity-20"
                  }),
                  _createElementVNode("div", null, [
                    _cache[25] || (_cache[25] = _createElementVNode("div", null, "Название карты", -1)),
                    _createElementVNode("div", _hoisted_33, [
                      _createVNode(_component_InputComponent, {
                        placeholder: "Любое имя, кроме номера карты",
                        rounded: "lg",
                        model: _ctx.cardName,
                        disabled: _ctx.hasRequest,
                        modelValue: _ctx.cardName,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.cardName) = $event)),
                        pattern: "[^0-9]*",
                        height: "h-10",
                        maxlength: "30",
                        border: false,
                        onKeyup: _cache[12] || (_cache[12] = ($event: any) => (_ctx.removeNumberInName('cardName')))
                      }, null, 8, ["model", "disabled", "modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _cache[26] || (_cache[26] = _createElementVNode("div", null, "Номер карты", -1)),
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(_component_InputComponent, {
                        placeholder: "4144 7656 6633 3232",
                        rounded: "lg",
                        model: _ctx.cardNumber,
                        modelValue: _ctx.cardNumber,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.cardNumber) = $event)),
                        height: "h-10",
                        disabled: _ctx.hasRequest,
                        type: "tel",
                        mask: '#### #### #### #### ###',
                        border: false
                      }, null, 8, ["model", "modelValue", "disabled"])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isSendOtp)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _createVNode(_component_CardIcon, {
                    color: "#FFD92F",
                    class: "absolute bottom-0 right-0 rounded-br-md opacity-20"
                  }),
                  _createElementVNode("div", null, [
                    (_ctx.typeOtp === 'phone')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [...(_cache[27] || (_cache[27] = [
                          _createTextVNode(" На ваш телефон поступит звонок ", -1),
                          _createElementVNode("div", null, "Возьмите трубку и прослушайте код", -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.typeOtp === 'telegram')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [...(_cache[28] || (_cache[28] = [
                          _createTextVNode(" На ваш Telegram поступил код ", -1),
                          _createElementVNode("div", null, "Прочитайте и впишите ниже", -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_39, [
                      _createVNode(_component_InputComponent, {
                        placeholder: 
                    _ctx.typeOtp == 'phone' ? 'Код из звонка' : 'Код из Telegram'
                  ,
                        rounded: "lg",
                        model: _ctx.otpNumber,
                        modelValue: _ctx.otpNumber,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.otpNumber) = $event)),
                        disabled: _ctx.hasRequest,
                        height: "h-10",
                        maxlength: "5",
                        type: "tel",
                        border: false
                      }, null, 8, ["placeholder", "model", "modelValue", "disabled"])
                    ]),
                    (_ctx.callTries < 3 && _ctx.typeOtp == 'phone')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          (_ctx.nextCallTime > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_40, " Позвонить еще раз (" + _toDisplayString(_ctx.nextCallTime) + "c) ", 1))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "mt-2 flex cursor-pointer justify-center text-blue",
                                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.onSubmitNewCard && _ctx.onSubmitNewCard(...args)))
                              }, " Позвонить еще раз "))
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.typeOtp === 'phone')
                    ? (_openBlock(), _createBlock(_component_TelegramBanner, {
                        key: 0,
                        class: "mt-5"
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])), [
            [_directive_auto_animate]
          ])
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", null, [
          (_ctx.isAddCard && !_ctx.isSendOtp)
            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                _createVNode(_component_ButtonComponent, {
                  "input-class": "px-10",
                  rounded: "lg",
                  height: "10",
                  loading: _ctx.hasRequest,
                  onClickAction: _ctx.onSubmitNewCard,
                  title: _ctx.validateSaveButtonName(),
                  disabled: !_ctx.validateCard || !_ctx.cardName.length
                }, null, 8, ["loading", "onClickAction", "title", "disabled"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isSendOtp)
            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                _createVNode(_component_ButtonComponent, {
                  "input-class": "px-10",
                  loading: _ctx.hasRequest,
                  rounded: "lg",
                  height: "10",
                  onClickAction: _ctx.codeConfirmation,
                  title: "Сохранить",
                  disabled: _ctx.otpNumber.length != 5
                }, null, 8, ["loading", "onClickAction", "disabled"])
              ]))
            : _createCommentVNode("", true)
        ])), [
          [_directive_auto_animate]
        ])
      ]),
      _createVNode(_component_StatusModal, {
        type: "success",
        description: "Реквизит успешно добавлен",
        "button-text": "Супер",
        onConfirm: _ctx.routeBack,
        state: _ctx.stateSuccessAddCard
      }, null, 8, ["onConfirm", "state"]),
      _createVNode(_component_WikiComponent, { link: "https://help.force2.ru/#/docs/addcard" })
    ]),
    _: 1
  }))
}